<template>
  <div class="rule_content">
    <h2>{{$t('score.score_rules')}}</h2>
   <p>1.什么是用户积分</p>
    <p>********</p>
    <p>2.如何获取用户积分</p>
    <p>********</p>
    <p>********</p>
    <p>********</p>
    <p>3.用户积分用途</p>
    <p>********</p>
    <p>********</p>
    <p>4.用户积分有效期</p>
    <p>********</p>
    <p>5.其他</p>
    <p>********</p>
  </div>
</template>

<script>
  export default {
    name: "scoreRule"
  }
</script>

<style lang="less" scoped>
  .rule_content {
    user-select: none;
    padding: 10px;
    z-index: 2002;
    background: black;
    border: white 2px solid;
    border-radius: 5px;
    max-height: 500px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/scoreRule.vue